// extracted by mini-css-extract-plugin
module.exports = {"container":"PlainStripe_container__1FFLp","fakeIframe":"PlainStripe_fakeIframe__3tk9L"};